<template>
<div class="download-menu-wrap">
  <div v-for="(item, index) in menu" :key='index' class="download-menu-item" :style="{background: item.bgColor}">
    <a @click="goUrl(item.url)">
      {{item.label}}
      <i class="iconfont " :class="item.icon"></i>
    </a>
  </div>
</div>
</template>

<script>
import common from '../../util/common'
export default {
  data () {
    return {
    }
  },
  computed: {
    menu () {
      return [{
        label: '题卡工具',
        url: `${window.location.protocol}//rescource-scan.oss-cn-shanghai.aliyuncs.com/hytMakePaperSoft.exe?t=${common.getTimeKey()}`,
        icon: 'icon-xiangxia5',
        bgColor: '#3d813d'
      }, {
        label: '扫描工具',
        url: `${window.location.protocol}//rescource-scan.kaow.cn/setup_V1.54.exe?t=${common.getTimeKey()}`,
        icon: 'icon-xiangxia5',
        bgColor: '#408640'
      }, {
        label: '应用中心',
        url: '/download.html',
        icon: 'icon-xiangyou3',
        bgColor: '#438b43'
      }, {
        label: '帮助手册',
        url: '/help',
        icon: 'icon-diannao',
        bgColor: 'rgb(81 157 81)'
      }]
    }
  },
  methods: {
    goUrl(url) {
      window.open(url)
    }
  },
  components: {

  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.download-menu-wrap {
  position: absolute;
  bottom: 0;
  width: 162px;
  height: 187px;
  border-top: 1px solid #00b22d;
  .download-menu-item{
    text-align: center;
    a{
      font-size: 14px;
      line-height: 2.6;
      color: #e9e9e9;
      display: inline-block;
      cursor: pointer;
      text-decoration: none;
      .iconfont{
        margin-left: 12px;
        font-size: 18px;
        vertical-align: middle;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/DownloadMenu.vue